import { isAudit, isEngagement, isRole } from "PFApp/activities/helpers";
import { TemplateKey } from "PFApp/constants/templates";
import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { Notification } from "PFCore/types";
import { Trans } from "react-i18next";

import { NotificationChangelog } from "./notification_changelog";

type NotificationMetadataProps = {
  notification: Notification;
};

export const NotificationMetadata = ({ notification }: NotificationMetadataProps) => {
  const { metadata } = notification;
  const templateKey = (metadata?.templateKey || "") as TemplateKey;
  const isAuditNotification = isAudit(templateKey);
  const isRoleNotification = isRole(templateKey);
  const isEngagementNotification = isEngagement(templateKey);
  const engagementKey = isAuditNotification
    ? "notifications.activityName.auditEngagement"
    : "notifications.activityName.engagement";
  const roleKey = isAuditNotification
    ? "notifications.activityName.auditRole"
    : "notifications.activityName.role";

  return (
    <>
      <NotificationChangelog changes={metadata?.changes} />
      <Stack gap={null}>
        {isRoleNotification && metadata?.parentActivityName && (
          <Typography variant="labelRegular">
            <Trans i18nKey={engagementKey} values={{ name: metadata.parentActivityName }} />
          </Typography>
        )}
        {(isRoleNotification || isEngagementNotification) && metadata?.activityName && (
          <Typography variant="labelRegular">
            <Trans
              i18nKey={isRoleNotification ? roleKey : engagementKey}
              values={{ name: metadata.activityName }}
            />
          </Typography>
        )}
      </Stack>
    </>
  );
};
